"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};function n(r) {
    if (t[r]) return t[r].exports;var s = t[r] = { i: r, l: !1, exports: {} };return e[r].call(s.exports, s, s.exports, n), s.l = !0, s.exports;
  }return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: r });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var r = Object.create(null);if (n.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var s in e) {
      n.d(r, s, function (t) {
        return e[t];
      }.bind(null, s));
    }return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 121);
}({ 0: function _(e, t) {
    e.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(e, t) {
          var n = void 0;"function" == typeof Event ? n = new Event(t) : (n = document.createEvent("Event"), n.initEvent(t, !0, !0)), e.dispatchEvent(n);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(e, t) {
          return t ? document.querySelector("[" + e + "=\"" + t + "\"]") : document.querySelector("[" + e + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(e, t) {
          return t ? document.querySelectorAll("[" + e + "=\"" + t + "\"]") : document.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(e, t, n) {
          return n ? e.querySelector("[" + t + "=\"" + n + "\"]") : e.querySelector("[" + t + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(e) {
          return Array.prototype.slice.call(e.parentElement.querySelectorAll(":hover")).filter(function () {
            return e[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(e, t, n) {
          return n ? e.querySelectorAll("[" + t + "=\"" + n + "\"]") : e.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(e, t) {
          return e.querySelector("." + t);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(e) {
          var t = void 0;return "function" == typeof Event ? t = new Event(e) : (t = document.createEvent("Event"), t.initEvent(e, !0, !0)), t;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(e) {
          var t = void 0;if (null != e) if (void 0 === e.code) switch (e.keyCode) {case 13:
              t = "Enter";break;case 38:
              t = "ArrowUp";break;case 40:
              t = "ArrowDown";break;case 8:
              t = "Backspace";break;case 9:
              t = "Tab";break;case 27:
              t = "Escape";break;case 33:
              t = "PageUp";break;case 34:
              t = "PageDown";break;case 32:
              t = "Space";break;default:
              t = void 0;} else t = e.code;return t;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(e) {
          return [].concat(_toConsumableArray(e.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (e) {
            return !function (e) {
              return "hidden" === window.getComputedStyle(e).visibility;
            }(e) && !e.hasAttribute("disabled") && !e.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 121: function _(e, t, n) {
    e.exports = n(122);
  }, 122: function _(e, t, n) {
    "use strict";
    n.r(t), n.d(t, "Selector", function () {
      return o;
    });var r = n(0),
        s = n.n(r),
        i = n(2);
    var o = function () {
      function o(e) {
        _classCallCheck(this, o);

        this.element = e, this.dropdown = s.a.getElementByAttributeWithinElement(this.element, this.attributes.dropdown), this.content = s.a.getElementByAttributeWithinElement(this.element, this.attributes.content), this.pointer = s.a.getElementByAttributeWithinElement(this.element, this.attributes.pointer), this.overlay = s.a.getElementByAttribute(this.attributes.overlay), this.keystroke = 0, this.elementIsOpen, this.addEventHandlers();
      }

      _createClass(o, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.dropdown.addEventListener("click", function (e) {
            e.preventDefault(), _this.dropdown.classList.contains(_this.classes.selectorDropDownActive) ? _this.closeContent() : _this.openContent();
          }), null !== this.overlay && this.overlay.addEventListener("click", function () {
            _this.closeContent();
          }), window.addEventListener("resize", function () {
            _this.dropdown.classList.contains(_this.classes.selectorDropDownActive) && _this.setPointer();
          }), document.addEventListener("keydown", function (e) {
            _this.handleButtonKeys(e);
          });
        }
      }, {
        key: "handleButtonKeys",
        value: function handleButtonKeys(e) {
          if (null != e) switch (s.a.getKeyCodeOnKeyDownEvent(e)) {case "Tab":
              Object(i.a)(e, this.content, this.elementIsOpen, this.keystroke), this.elementIsOpen && this.keystroke++;break;case "Escape":case "Backspace":
              this.elementIsOpen && (this.closeContent(), this.dropdown.focus());}
        }
      }, {
        key: "closeContent",
        value: function closeContent() {
          this.elementIsOpen = !1, this.dropdown.classList.remove(this.classes.selectorDropDownActive), this.content.classList.remove(this.classes.selectorContentActive), this.dropdown.setAttribute("aria-expanded", "false"), this.content.setAttribute("aria-hidden", "true"), null !== this.overlay && this.overlay.classList.remove(this.classes.modalOverlayActive), this.keystroke = 0;
        }
      }, {
        key: "openContent",
        value: function openContent() {
          this.elementIsOpen = !0, this.dropdown.classList.add(this.classes.selectorDropDownActive), this.content.classList.add(this.classes.selectorContentActive), this.setPointer(), this.dropdown.setAttribute("aria-expanded", "true"), this.content.setAttribute("aria-hidden", "false"), null !== this.overlay && this.overlay.classList.add(this.classes.modalOverlayActive);
        }
      }, {
        key: "setPointer",
        value: function setPointer() {
          var e = Math.round(window.getComputedStyle(this.dropdown, null).getPropertyValue("padding-right").replace("px", "")),
              t = this.dropdown.childNodes;var n = void 0;for (var _e = 0; _e < t.length; _e++) {
            if (null != t[_e].classList && t[_e].classList.contains("icon")) {
              ("none" !== getComputedStyle(t[_e]).getPropertyValue("display") ? t[_e] : null) && (n = getComputedStyle(t[_e]).getPropertyValue("width").replace("px", ""));
            }
          }this.pointer.style.left = this.dropdown.offsetWidth - e - this.pointer.getBoundingClientRect().width / 2 + this.dropdown.offsetLeft - n / 3 + 1 + "px";
        }
      }, {
        key: "attributes",
        get: function get() {
          return { content: "data-rs-selector-content", dropdown: "data-rs-selector-dropdown", overlay: "data-rs-selector-overlay", pointer: "data-rs-selector-pointer" };
        }
      }, {
        key: "classes",
        get: function get() {
          return { selectorDropDownActive: "selector__dropdown--active", selectorContentActive: "selector-box--active", modalOverlayActive: "modal__overlay--active" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-selector]";
        }
      }]);

      return o;
    }();
  }, 2: function _(e, t, n) {
    "use strict";
    var r = n(0),
        s = n.n(r);t.a = function (e, t, n) {
      var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var i = s.a.getKeyboardFocusableElements(t),
          o = i[0],
          a = i[i.length - 1];if (n) {
        if (a.tagName && "IFRAME" === a.tagName) {
          var _e2 = document.createElement("div");_e2.setAttribute("tabindex", "0"), a.parentNode.insertBefore(_e2, a.nextSibling);
        }if (o.tagName && "IFRAME" === o.tagName) {
          var _e3 = document.createElement("div");_e3.setAttribute("tabindex", "0"), a.parentNode.insertBefore(_e3, a.nextSibling), o.parentNode.insertBefore(_e3, o);
        }r < 1 && (e.preventDefault(), setTimeout(function () {
          o.focus();
        }, 100)), e.shiftKey ? document.activeElement === o && (e.preventDefault(), a.focus()) : document.activeElement === a && (e.preventDefault(), o.focus());
      }
    };
  } }));